import { FloatButton } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import {clrs} from "../../../constants/colors";

const ScrollDownButton = () => {
    const [visible, setVisible] = useState(false);

    // Проверка, чтобы кнопка появлялась только если есть что пролистывать вниз
    const checkScroll = () => {
        const scrollY = window.scrollY;
        const innerHeight = window.innerHeight;
        const scrollHeight = document.body.scrollHeight;
        setVisible(scrollY + innerHeight < scrollHeight - 50);
    };

    useEffect(() => {
        window.addEventListener('scroll', checkScroll);
        return () => window.removeEventListener('scroll', checkScroll);
    }, []);

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
        });
    };

    return visible ? (
        <FloatButton
            icon={<DownOutlined />}
            onClick={scrollToBottom}
            style={{
                backgroundColor: clrs.blueForIcon,
                border: '0px',
                right: '110px',
            }}
        />
    ) : null;
};

export default ScrollDownButton;
